export default (theme) => ({
    subtitle: {
        fontSize: '1rem',
        marginLeft: 30,

        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },

    gridSubContainer_row2: {
        width: '100% !important',
        margin: '0 !important',
        '& .MuiGrid-root.MuiGrid-item': {
            paddingTop: '0px',
            paddingBottom: '0px',
            [theme.breakpoints.down('md')]: {
                padding: '0',
            },
        },
        '& .MuiGrid-root.MuiGrid-item:first-child': {
            paddingLeft: '0px',
        },
        '& .MuiGrid-root.MuiGrid-item:last-child': {
            paddingRight: '0px',
        },
    },

    gridSubContainer_row3: {
        width: '100% !important',
        margin: '0 !important',
        '& .MuiGrid-root.MuiGrid-item': {
            paddingTop: '0px',
            paddingBottom: '0px',
            [theme.breakpoints.down('sm')]: {
                padding: '0',
            },
        },
        '& .MuiGrid-root.MuiGrid-item:first-child': {
            paddingLeft: '0px',
        },
        '& .MuiGrid-root.MuiGrid-item:last-child': {
            paddingRight: '0px',
        },
    },

    gridSubContainer_costs: {
        width: '100% !important',
        margin: '0 !important',
        '& .MuiGrid-root.MuiGrid-item': {
            paddingTop: '0px',
            paddingBottom: '0px',
            [theme.breakpoints.down('sm')]: {
                padding: '0',
            },
        },
        '& .MuiGrid-root.MuiGrid-item:first-child': {
            paddingLeft: '0px',
            [theme.breakpoints.down('md')]: {
                paddingRight: '0',
            },
        },
        '& .MuiGrid-root.MuiGrid-item:nth-child(2)': {
            [theme.breakpoints.down('md')]: {
                paddingLeft: '0',
            },
        },
        '& .MuiGrid-root.MuiGrid-item:last-child': {
            paddingRight: '0px',
        },
    },

    gridSubContainer_StreetRef: {
        width: '100% !important',
        margin: '0 !important',
        '& .MuiGrid-root.MuiGrid-item': {
            paddingTop: '0px',
            paddingBottom: '0px',
            [theme.breakpoints.down('xs')]: {
                padding: '0',
            },
        },
        '& .MuiGrid-root.MuiGrid-item:first-child': {
            paddingLeft: '0px',
            [theme.breakpoints.down('md')]: {
                paddingRight: '0',
            },
        },
        '& .MuiGrid-root.MuiGrid-item:nth-child(2)': {
            [theme.breakpoints.down('md')]: {
                paddingLeft: '0',
                paddingRight: '12px',
            },
            [theme.breakpoints.down('xs')]: {
                paddingRight: '0',
            },
        },
        '& .MuiGrid-root.MuiGrid-item:last-child': {
            paddingRight: '0px',
            [theme.breakpoints.down('md')]: {
                paddingLeft: '12px',
            },
            [theme.breakpoints.down('xs')]: {
                paddingLeft: '0',
            },
        },
    },

    newTTN_formLabel: {
        color: '#212121',
        margin: '30px 0px 8px',
    },
    formLabel_margin_sm: {
        [theme.breakpoints.down('sm')]: {
            marginTop: '30px !important',
        },
    },

    selectCost_box: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
    },
    selectCost_costs: {
        color: '#9e9e9e',
        fontSize: '0.875rem',
        display: 'flex',

        '& > span': {
            cursor: 'pointer',
            color: '#3f51b5',
            marginLeft: '20px',
            display: 'block'
        },
    },
})
